import { render, staticRenderFns } from "./FooterContainer.vue?vue&type=template&id=05a3fc40&"
import script from "./FooterContainer.vue?vue&type=script&lang=js&"
export * from "./FooterContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports